"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodeBlock = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const use_codemirror_1 = require("use-codemirror");

const Wrapper = material_1.styled("div")`
  & .CodeMirror {
    height: auto;
  }
  & .CodeMirror-lines {
    padding: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(3);
}};
  }
`;
const Code = material_1.styled("pre")`
  position: relative;
  display: block;
  padding: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(3);
}};
`;

function CodeBlock(_ref3) {
  let {
    code,
    mode = "toit",
    className
  } = _ref3;
  const codeMirrorTheme = "vars";
  const codeMirror = use_codemirror_1.useCodeMirror({
    value: code,
    importCodeMirrorAddons: () => {
      return Promise.all([Promise.resolve().then(() => __importStar(require("./toit"))), Promise.resolve().then(() => __importStar(require("codemirror/mode/shell/shell"))), Promise.resolve().then(() => __importStar(require("codemirror/keymap/sublime")))]);
    },
    config: {
      theme: codeMirrorTheme,
      mode: mode,
      readOnly: true,
      autoScroll: false,
      scrollbarStyle: "native",
      tabSize: 2
    }
  });
  return react_1.default.createElement(Wrapper, {
    className: className
  }, react_1.default.createElement(Code, {
    className: codeMirrorTheme,
    ref: codeMirror.ref,
    "data-testid": "code-container"
  }, code));
}

exports.CodeBlock = CodeBlock;
exports.default = CodeBlock;